/*
 * discount-engine.js — Rabattcode-Vorschau auf der Produktseite (Block blocks/discount-engine.liquid).
 * 27.09.2026: aus dem Inline-Skript des Blocks ausgelagert. Vorher standen diese ~14 KB in jeder Produktseite
 * und in jeder Sektions-Antwort beim Variantenwechsel; jetzt eine gecachte Datei, mit `defer` geladen.
 * Logik unveraendert (Storefront-API cartCreate zur Pruefung, Preis-Override per Selektor, Uebernahme des
 * Codes beim Klick auf 'In den Warenkorb', Wiederherstellung aus dem Korb beim Laden). Einzige Aenderung:
 * root wird ohne Liquid als erstes [data-discount-engine] gefunden.
 * Schnittstelle unveraendert: window.DiscountPreviewEngine.checkCode(code), Events discount-preview:ready /
 * discount-preview:restored (genutzt von blocks/discount-input.liquid).
 */
  (function () {
    // Der Block ist global (ein Exemplar je Produktseite); die Varianten-ID steht in seinen data-Attributen.
    var root = document.querySelector('[data-discount-engine]');
    if (!root || root.dataset.discountEngineInitialized) return;
    root.dataset.discountEngineInitialized = 'true';

    var variantId = root.dataset.variantId;
    var shopDomain = root.dataset.shopDomain;
    var apiVersion = root.dataset.apiVersion;
    var storefrontToken = root.dataset.storefrontToken;
    var addToCartSelector = root.dataset.addToCartSelector;
    var priceSelector = (root.dataset.priceSelector || '').replace(/__VARIANT_ID__/g, variantId);
    var comparePriceSelector = (root.dataset.comparePriceSelector || '').replace(/__VARIANT_ID__/g, variantId);

    var originalPriceAmount = parseFloat(root.dataset.originalPrice);
    var originalComparePriceRaw = root.dataset.originalComparePrice;
    var hasNativeCompare = originalComparePriceRaw !== '';
    var originalComparePriceAmount = hasNativeCompare ? parseFloat(originalComparePriceRaw) : null;

    var validatedCode = null;
    var graphqlEndpoint = 'https://' + shopDomain + '/api/' + apiVersion + '/graphql.json';

    function deepQuerySelector(selector, searchRoot) {
      searchRoot = searchRoot || document;
      if (!selector) return null;
      var found = searchRoot.querySelector(selector);
      if (found) return found;
      var all = searchRoot.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        if (all[i].shadowRoot) {
          found = deepQuerySelector(selector, all[i].shadowRoot);
          if (found) return found;
        }
      }
      return null;
    }

    function deepQuerySelectorAll(selector, searchRoot, results) {
      searchRoot = searchRoot || document;
      results = results || [];
      if (!selector) return results;
      searchRoot.querySelectorAll(selector).forEach(function (el) {
        results.push(el);
      });
      searchRoot.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) {
          deepQuerySelectorAll(selector, el.shadowRoot, results);
        }
      });
      return results;
    }

    function formatMoney(amount) {
      // Geschütztes Leerzeichen zwischen Preis und Euro-Zeichen (kein Umbruch).
      return amount.toFixed(2).replace('.', ',') + ' €';
    }

    function resetPriceDisplay() {
      deepQuerySelectorAll(priceSelector).forEach(function (el) {
        el.textContent = formatMoney(originalPriceAmount);
      });
      deepQuerySelectorAll(comparePriceSelector).forEach(function (el) {
        if (hasNativeCompare) {
          el.textContent = formatMoney(originalComparePriceAmount);
        }
        var group = el.closest('[role="group"]');
        if (group) {
          group.style.display = hasNativeCompare ? '' : 'none';
        }
      });
      deepQuerySelectorAll('[data-discount-preview-generated]').forEach(function (el) {
        el.remove();
      });
    }

    function getOrCreateCompareElement(priceEl) {
      var existing = priceEl.parentElement
        ? priceEl.parentElement.querySelector('[data-discount-preview-generated]')
        : null;
      if (existing) return existing;

      var span = document.createElement('span');
      span.className = 'compare-at-price';
      span.setAttribute('data-discount-preview-generated', 'true');
      span.style.marginLeft = '0.5em';
      span.style.textDecoration = 'line-through';
      span.style.opacity = '0.6';
      priceEl.insertAdjacentElement('afterend', span);
      return span;
    }

    function applyPriceOverride(before, after) {
      deepQuerySelectorAll(priceSelector).forEach(function (el) {
        el.textContent = formatMoney(after);
      });

      if (hasNativeCompare) return;

      var compareEls = deepQuerySelectorAll(comparePriceSelector);

      if (compareEls.length === 0) {
        deepQuerySelectorAll(priceSelector).forEach(function (priceEl) {
          var created = getOrCreateCompareElement(priceEl);
          created.textContent = formatMoney(before);
        });
        return;
      }

      compareEls.forEach(function (el) {
        el.textContent = formatMoney(before);
        var group = el.closest('[role="group"]');
        if (group) {
          group.style.display = '';
        }
      });
    }

    function graphqlRequest(query, variables) {
      return fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken
        },
        body: JSON.stringify({ query: query, variables: variables })
      }).then(function (res) {
        return res.json();
      });
    }

    var CART_CREATE_QUERY =
      'mutation cartCreate($lines: [CartLineInput!], $discountCodes: [String!]) {' +
      '  cartCreate(input: { lines: $lines, discountCodes: $discountCodes }) {' +
      '    cart {' +
      '      id' +
      '      discountCodes { code applicable }' +
      '      discountAllocations { discountedAmount { amount currencyCode } }' +
      '      lines(first: 1) {' +
      '        edges {' +
      '          node {' +
      '            cost { subtotalAmount { amount currencyCode } }' +
      '            discountAllocations { discountedAmount { amount currencyCode } }' +
      '          }' +
      '        }' +
      '      }' +
      '    }' +
      '    userErrors { field message }' +
      '  }' +
      '}';

    function sumDiscountAllocations(allocations) {
      if (!allocations || !allocations.length) return 0;
      return allocations.reduce(function (sum, allocation) {
        return sum + parseFloat(allocation.discountedAmount.amount);
      }, 0);
    }

    function checkCode(code) {
      code = (code || '').trim();
      if (!code) {
        return Promise.resolve({ ok: false, message: '' });
      }

      validatedCode = null;
      resetPriceDisplay();

      var merchandiseGid = 'gid://shopify/ProductVariant/' + variantId;

      return graphqlRequest(CART_CREATE_QUERY, {
        lines: [{ merchandiseId: merchandiseGid, quantity: 1 }],
        discountCodes: [code]
      })
        .then(function (result) {
          if (result.errors) {
            throw new Error(result.errors[0].message);
          }

          var payload = result.data.cartCreate;
          if (payload.userErrors && payload.userErrors.length) {
            throw new Error(payload.userErrors[0].message);
          }

          var cart = payload.cart;
          var discountInfo = cart.discountCodes && cart.discountCodes[0];
          var lineNode = cart.lines.edges[0] && cart.lines.edges[0].node;

          if (!discountInfo || !discountInfo.applicable || !lineNode) {
            return { ok: false, message: 'Dieser Code ist ungültig oder auf dieses Produkt nicht anwendbar.' };
          }

          var before = parseFloat(lineNode.cost.subtotalAmount.amount);
          var lineDiscount = sumDiscountAllocations(lineNode.discountAllocations);
          var cartDiscount = sumDiscountAllocations(cart.discountAllocations);
          var totalDiscount = lineDiscount + cartDiscount;
          var after = before - totalDiscount;

          if (totalDiscount <= 0) {
            return { ok: false, message: 'Dieser Code bringt für dieses Produkt keinen Preisvorteil.' };
          }

          applyPriceOverride(before, after);
          validatedCode = code;
          return { ok: true, message: 'Code gültig – Rabatt wird beim Klick auf "In den Warenkorb" übernommen.' };
        })
        .catch(function (err) {
          console.error(err);
          return { ok: false, message: 'Code konnte nicht geprüft werden. Bitte versuche es erneut.' };
        });
    }

    function applyValidatedDiscountToCart() {
      if (!validatedCode) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: validatedCode })
      }).catch(function (err) {
        console.error(err);
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!addToCartSelector || !event.target || !event.target.closest) return;
        if (event.target.closest(addToCartSelector)) {
          setTimeout(applyValidatedDiscountToCart, 300);
        }
      },
      true
    );

    function notifyRestored(code, message) {
      document.dispatchEvent(
        new CustomEvent('discount-preview:restored', { detail: { code: code, message: message } })
      );
    }

    function restoreDiscountFromCart() {
      return fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var matchingItem = (cart.items || []).find(function (item) {
            return (
              String(item.variant_id) === String(variantId) &&
              item.discounts &&
              item.discounts.length > 0 &&
              item.original_price > item.final_price
            );
          });

          if (matchingItem) {
            var before = matchingItem.original_price / 100;
            var after = matchingItem.final_price / 100;
            applyPriceOverride(before, after);
            var codeTitle = matchingItem.discounts[0].title;
            if (codeTitle) validatedCode = codeTitle;
            notifyRestored(codeTitle, 'Dieser Rabattcode ist bereits in deinem Warenkorb aktiv.');
            return true;
          }

          var globalPercentDiscount = (cart.cart_level_discount_applications || []).find(function (app) {
            var valueType = app.value_type || app.type;
            return valueType === 'percentage' && (app.target_selection === 'all' || !app.target_selection);
          });

          if (globalPercentDiscount) {
            var percentValue = parseFloat(globalPercentDiscount.value);
            if (!isNaN(percentValue) && percentValue > 0) {
              var beforeGlobal = originalPriceAmount;
              var afterGlobal = beforeGlobal * (1 - percentValue / 100);
              applyPriceOverride(beforeGlobal, afterGlobal);
              var globalTitle = globalPercentDiscount.title;
              if (globalTitle) validatedCode = globalTitle;
              notifyRestored(globalTitle, 'Dieser Rabattcode ist bereits in deinem Warenkorb aktiv.');
              return true;
            }
          }

          return false;
        })
        .catch(function (err) {
          console.error('Rabattcode-Vorschau: Warenkorb konnte nicht geprüft werden.', err);
          return false;
        });
    }

    window.DiscountPreviewEngine = {
      checkCode: checkCode
    };
    document.dispatchEvent(new CustomEvent('discount-preview:ready'));

    restoreDiscountFromCart().then(function (restored) {
      if (restored) return;

      var urlParam = root.dataset.urlParam;
      if (!urlParam) return;

      var searchParams = new URLSearchParams(window.location.search);
      var codeFromUrl = searchParams.get(urlParam);
      if (codeFromUrl) {
        checkCode(codeFromUrl).then(function (result) {
          notifyRestored(codeFromUrl, result.message);
        });
      }
    });
  })();
